import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotices } from '../data/content';
const MINUTES = ['2', '3', '5', '7', '8', '11', '14'];
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const timers = useRef<number[]>([]);
  useEffect(() => {
    if (dismissed) return;
    let cancelled = false;
    const cycle = (i: number) => {
      const showAt = window.setTimeout(() => {
        if (cancelled) return;
        setIndex(i % purchaseNotices.length);
        setVisible(true);
        const hideAt = window.setTimeout(() => {
          if (cancelled) return;
          setVisible(false);
          cycle(i + 1);
        }, 5200);
        timers.current.push(hideAt);
      }, i === 0 ? 6000 : 11000);
      timers.current.push(showAt);
    };
    cycle(0);
    return () => {
      cancelled = true;
      timers.current.forEach(t => window.clearTimeout(t));
      timers.current = [];
    };
  }, [dismissed]);
  const notice = purchaseNotices[index];
  const minutes = MINUTES[index % MINUTES.length];
  return <AnimatePresence data-id="element-38" data-mp="1fv0w43sg472y">
      {visible && !dismissed ? <motion.div initial={{
      x: -24,
      opacity: 0,
      scale: 0.96
    }} animate={{
      x: 0,
      opacity: 1,
      scale: 1
    }} exit={{
      x: -24,
      opacity: 0,
      scale: 0.96
    }} transition={{
      duration: 0.28,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-3 right-3 z-50 sm:bottom-6 sm:right-auto sm:left-6 sm:max-w-sm" role="status" aria-live="polite" data-id="element-39" data-mp="1awfrzta2p398">
          <div className="relative flex items-start gap-3 rounded-2xl bg-white p-3.5 pr-9 shadow-[0_16px_40px_rgba(28,19,48,0.22)] ring-1 ring-ink/10" data-id="element-40" data-mp="s5exbhfzjtvh">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-teal-soft" data-id="element-41" data-mp="23ln1fnb2fd99">
              <CheckCircle2Icon className="h-5 w-5 text-teal" aria-hidden="true" data-id="element-42" data-mp="2ap3037xgwma4" />
            </span>
            <div className="min-w-0" data-id="element-43" data-mp="2fn4qyf14xpw5">
              <p className="text-[13.5px] font-bold leading-snug text-plum-deep" data-id="element-44" data-mp="2fm38vqlpc34x">
                {notice.name} <span className="font-medium text-ink/70" data-id="element-45" data-mp="2knad5fomyk6u">ha appena acquistato</span>
              </p>
              <p className="text-[13px] font-semibold leading-snug text-ink/80" data-id="element-46" data-mp="2plbyy8dg4xm0">
                Progetto Clinico della Menopausa™
              </p>
              <p className="mt-1 text-[11.5px] font-medium text-ink/50" data-id="element-47" data-mp="1wwwswbcalpmt">
                {notice.place} • {minutes} minuti fa
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Chiudi notifica" className="absolute right-2 top-2 rounded-full p-1.5 text-ink/35 transition-colors duration-150 ease-out hover:bg-ink/5 hover:text-ink/70" data-id="element-48" data-mp="21u6hjoruxx9l">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-49" data-mp="1e4c5h9fd4cqe" />
            </button>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}